import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import ReactModal from 'react-modal';

import { i18next } from '../../../../internationalization/i18next';
import { LearningType } from '../../../../stores/quiz-results-store';
import { CloseIcon, FilterSVGIcon } from '../../../common/icons';
import { Button } from '../../../widgets/button/button';
import { Item, SearchableCheckItemSet } from '../../../widgets/searchable-check-item-set/searchable-check-item-set';

ReactModal.setAppElement('#root');

const styles = require('../filter.css');

interface LearningTypeFilterProps {
  // extends WithI18nProps {
  initial: LearningType[];
  // defaultRoleId: string;
  allPriorities: LearningType[];
  // competencyMap: StringKeyMap<DbKey<Competency>, Competency>;

  onCancel(): void;
  onDone(selected: string[]): void;
}

interface Toggle {
  label: string;
  detail: string;
}

@observer
export class LearningTypeFilter extends React.Component<LearningTypeFilterProps> {
  // @observable
  // searchState: InputState = textFieldState();

  @observable
  selected: LearningType[] = this.props.initial;

  render() {
    // console.log("DEBUG RolesFilter render: inital/default/other/map: ",
    //   this.props.initial, this.props.defaultRoleId, this.props.otherRoleIds, this.props.rolesMap);
    return (
      <ReactModal
        isOpen={true}
        shouldCloseOnEsc={true}
        shouldCloseOnOverlayClick={true}
        onRequestClose={this.props.onCancel}
        className={styles.modal}
      >
        {this.renderCloseButton()}
        {this.renderTitle()}
        {/* {this.renderSearch()} */}
        {this.renderCheckItems()}
        <br />
        {this.renderButtons()}
      </ReactModal>
    );
  }

  renderCloseButton(): JSX.Element {
    return (
      <div className={styles.closeButton}>
        <CloseIcon onClick={this.props.onCancel} size={'xsmall'} />
      </div>
    );
  }

  renderTitle(): JSX.Element {
    return (
      <div className={styles.title}>
        <FilterSVGIcon className={styles.filterIcon} size={'small'} />
        <div className={styles.titleText}>
          {i18next.t('filters.recommendation-priorities.title', 'Priority Selection')}
        </div>
      </div>
    );
  }

  // renderSearch(): JSX.Element {
  //   return (
  //     <div className={styles.search}>
  //       <TextInput
  //         placeholder={i18next.t("filters.placeholder","Search")}
  //         state={this.searchState}
  //         type={"text"}
  //       />
  //     </div>
  //   );
  // }

  renderCheckItems(): JSX.Element {
    // /// We are going to put the default role first in the list, but we don't want it to be
    // /// duplicated further down, so weed it out if it's there
    // const defaultItemIdx = this.items.findIndex(item => item.id === this.props.defaultRoleId);
    // if (defaultItemIdx >= 0) { this.items.splice(defaultItemIdx, 1); }
    // /// Case-insensitive search - first clean up the expression so it's a valid regex
    // const term = this.searchState.value().replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    // const re = new RegExp(term, 'i');
    this.items.sort((a, b) => a.value.label.localeCompare(b.value.label));
    return (
      <div className={styles.checkItems}>
        <SearchableCheckItemSet
          items={
            // [this.idToItem(this.props.defaultRoleId, this.rolesSelected.concat(this.props.defaultRoleId))]
            // .concat(
            this.items
            // )
            // .filter(i => i.value.label.search(re) !== -1)
          }
          hintText={t => t.detail}
          label={t => t.label}
          onChange={this.onChange}
          selectAllVisible={false}
        />
      </div>
    );
  }

  renderButtons(): JSX.Element {
    return (
      <div className={styles.buttons}>
        <Button
          // className={classnames(styles.button, styles.clear)}
          variant={'tertiary'}
          onClick={async () => this.onClear()}
        >
          {i18next.t('filters.clear', 'Clear Filter')}
        </Button>
        <Button
          // className={classnames(styles.button, styles.report)}
          onClick={async () => this.props.onDone(this.selectedIds)}
          disabled={false}
        >
          {this.selectedIds.length > 0
            ? i18next.t('filters.recommendation-priorities.priorities', {
                count: this.selected.length,
                defaultValue: `Report on ${this.selected.length} Priorities`
              })
            : i18next.t('filters.recommendation-priorities.clear', 'Clear Priorities Selection')}
        </Button>
      </div>
    );
  }

  @action
  onClear(): void {
    this.selected = [];
  }

  @action
  onChange = (onChangeId: string): void => {
    // if (onChangeId === this.props.defaultRoleId) {
    //   return;
    // }
    const exists = this.selectedIds.find(id => onChangeId === id);
    // tslint:disable-next-line: prefer-conditional-expression
    if (exists) {
      this.selectedIds = this.selectedIds.filter(roleId => onChangeId !== roleId);
    } else {
      //} if (this.selectedIds.length < 3) { // Only select if there aren't already three selected
      this.selectedIds = this.selectedIds.concat(onChangeId as LearningType);
    }
  };

  @computed
  get selectedIds(): LearningType[] {
    return this.selected;
  }

  set selectedIds(ids: LearningType[]) {
    this.selected = ids;
  }

  @computed
  get allIds(): LearningType[] {
    return this.props.allPriorities;
  }

  @computed
  get items(): Item<Toggle>[] {
    return this.allIds.map(roleIds => this.idToItem(roleIds, this.selectedIds));
  }

  idToItem(id: LearningType, selected: LearningType[]): Item<Toggle> {
    return {
      id,
      selected: selected.includes(id),
      value: this.priorityToToggle(id)
    };
  }

  priorityToToggle(id: LearningType) {
    let label = '';
    switch (id) {
      // case "highly-recommended":
      //   label = i18next.t("tile-accordions.recommendations.highly-recommended", "Highly Recommended"); break;
      case 'recommendations':
        label = i18next.t('filters.recommendation-priorities.recommendations', 'Recommendations');
        break;
      // case "completed":
      //   label = i18next.t("tile-accordions.recommendations.completed", "Take Again"); break;
      default:
        label = i18next.t('filters.recommendation-priorities.all-learning', 'All Learning');
    }
    return {
      label,
      detail: ''
    };
  }
}

// export const CompetencyFilter = withI18n(CompetencyFilter0);

// function textFieldState(initialValue: string = "") {
//   const state = newTextField();
//   state.onChange(initialValue);
//   return state;
// }



// WEBPACK FOOTER //
// ./src/ui/components/filters/learning-type-filter/learning-type-filter.tsx